import React from 'react';
import cn from 'classnames';

import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import Suspend from 'shared/ui/icons/General/Suspend';
import TurnOn from 'shared/ui/icons/General/TurnOn';
import Delete from 'shared/ui/icons/General/Delete';

import styles from './ConfirmModal.module.scss';

export type ConfirmVariant = 'pause' | 'resume' | 'delete';

export type ConfirmHintTone = 'neutral' | 'warning';

const VARIANTS = {
    pause: {Icon: Suspend, background: styles.pauseBackground, wrapper: styles.pauseWrapper},
    resume: {Icon: TurnOn, background: styles.pauseBackground, wrapper: styles.pauseWrapper},
    delete: {Icon: Delete, background: styles.deleteBackground, wrapper: styles.deleteWrapper},
};

interface IConfirmModalProps {
    variant: ConfirmVariant,
    open: boolean,
    handleClose: () => void,
    header: string,
    title: React.ReactNode,
    name?: string,
    hint?: React.ReactNode,
    hintTone?: ConfirmHintTone,
    confirmText: string,
    onConfirm: () => void,
    isLoading?: boolean,
}

const ConfirmModal: React.FC<IConfirmModalProps> = ({
    variant,
    open,
    handleClose,
    header,
    title,
    name,
    hint,
    hintTone = 'neutral',
    confirmText,
    onConfirm,
    isLoading,
}) => {
    const {Icon, background, wrapper} = VARIANTS[variant];
    const hintClassName = cn(styles.hint, {[styles.hintWarning]: hintTone === 'warning'});

    return (
        <MainModal
            header={header}
            open={open}
            handleClose={handleClose}
            size="md"
            dialogClassName={background}
        >
            <ModalBodyWrapper>
                <div className={wrapper}>
                    <Icon width={64} height={64}/>
                    <div className={styles.text}>
                        <span className={styles.title}>{title}</span>
                        {name && <span className={styles.name}>«{name}»?</span>}
                        {hint && <span className={hintClassName}>{hint}</span>}
                    </div>
                </div>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={confirmText}
                primaryButtonType="submit"
                primaryButtonOnClick={onConfirm}
                primaryButtonLoading={isLoading}
                secondaryButtonOnClick={handleClose}
            />
        </MainModal>
    );
};

export default ConfirmModal;
